/**
 * Services API
 * Fetches service catalog from loyalty backend (public endpoints)
 */

import { apiClient } from './apiClient';

export interface Service {
  _id: string;
  name: string;
  category: string;
  subcategory?: string;
  description?: string;
  basePrice: number;
  commissionRate?: number;
  processingType?: 'instant' | 'approval';
  requiredDocuments?: string[];
  tatHours?: number;
  isActive: boolean;
}

export interface ServiceWithAnalytics extends Service {
  totalRequests?: number;
  totalEarnings?: number;
}

/**
 * Fetch all services (public)
 */
export async function getServices(params?: {
  category?: string;
  isActive?: boolean;
}): Promise<ServiceWithAnalytics[]> {
  const searchParams: Record<string, string> = {};
  if (params?.category) searchParams.category = params.category;
  if (params?.isActive !== undefined) searchParams.isActive = String(params.isActive);

  const response = await apiClient.get<ServiceWithAnalytics[]>(
    '/loyalty/services',
    searchParams
  );

  if (response.success && response.data) {
    return Array.isArray(response.data) ? response.data : [];
  }

  throw new Error(response.message || 'Failed to fetch services');
}

/**
 * Fetch a single service by ID (public)
 */
export async function getServiceById(id: string): Promise<Service> {
  const response = await apiClient.get<Service>(`/loyalty/services/${id}`);

  if (response.success && response.data) {
    return response.data;
  }

  throw new Error(response.message || 'Failed to fetch service');
}
